<template>
	<div class="wrap container">
    <router-view name="head"></router-view>
    <router-view></router-view>
		<router-view name="foot"></router-view>
	</div>
</template>
<script>
import animatecss from 'animate.css'
export default {  
  name: 'app',  
  data () {  
    return {  
      
    }  
  },  
  mounted () {  
  },
  watch: {  
   
  } 

}  
</script>
<style>
 @media screen and (max-width: 640px){ 
 .common_mbx{
    padding: 38px 0 33px 0;
    font-size: 14px;
    color: #383838;
    width: 1200px;
    margin: 0 auto;
  }
  .container{
    padding-bottom: 1.2rem;
    max-width: 6.4rem;
    margin: 0 auto;
    overflow: hidden;
  }
  .p_name p{
    overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  }
  .cpxq_wrap img{
    width: 100%;
    display: block;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/public/p_main.vue